import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';
import { AdfNode } from './AdfNode';

export const AdfExpand = React.memo(({ node }: AdfNodeProps) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const title = node.attrs?.title || 'Expand';

    return (
        <details className="expand" open={isExpanded}>
            <summary onClick={(e) => {
                e.preventDefault();
                setIsExpanded(!isExpanded);
            }}>
                {title}
            </summary>
            {isExpanded && (
                <div className="expand-content">
                    {node.content?.map((x, i) => <AdfNode key={i} node={x} />)}
                </div>
            )}
        </details>
    );
});
